export function productCategoryIds(p) {
  const out = [];
  const seen = new Set();
  const primary = (p?.category_id || "").trim();
  const extras = Array.isArray(p?.category_ids) ? p.category_ids : [];
  for (const raw of [primary, ...extras]) {
    const id = String(raw || "").trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    out.push(id);
  }
  return out;
}

export function productInCategory(p, catId, catSlug) {
  if (catId && productCategoryIds(p).includes(catId)) return true;
  if (catSlug && p?.category_slug === catSlug) return true;
  return false;
}
